
const CONSTANT = {};

if (process.env.NODE_ENV === 'development') {
    CONSTANT.BASE_API = `https://uat-api.tatinta.com/v1/`;
    CONSTANT.SHOP_API = `http://localhost:7500/v1/`;
    //CONSTANT.SHOP_API = `https://gateway.tatinta.com/v1/`;
    //CONSTANT.SHOP_API = `https://fapi.tadev.fun/v1/`;
    //CONSTANT.BASE_API = `https://api.tatinta.com/v1/`;
    CONSTANT.STATIC_URL = `https://tatinta-uat.s3.ap-southeast-1.amazonaws.com/`;
    CONSTANT.STATIC_URL_SV = 'https://uat-api.tatinta.com/v1/static/'
}
else {
    CONSTANT.BASE_API = `https://api.tatinta.com/v1/`;
    CONSTANT.STATIC_URL = `https://tatinta-static-s3.s3.ap-southeast-1.amazonaws.com/`;
    CONSTANT.SHOP_API = `https://gateway.tatinta.com/v1/`;
    CONSTANT.STATIC_URL_SV = 'https://api.tatinta.com/v1/static/'
}

// UAT
if (process.env.REACT_APP_UAT === 'uat') {
    CONSTANT.BASE_API = `https://uat-api.tatinta.com/v1/`;
    CONSTANT.STATIC_URL = `https://tatinta-uat.s3.ap-southeast-1.amazonaws.com/`;
    CONSTANT.SHOP_API = `https://fapi.tadev.fun/v1/`;
    CONSTANT.STATIC_URL_SV = 'https://uat-api.tatinta.com/v1/static/'
}


CONSTANT.API = {
    KEY: "hbacrxhfgxhplcwrmfg2cu0946496x",
    AUTH: {
        FORGOT_PASS: `${CONSTANT.BASE_API}auth/forgot-password`,
        GET_PASS: `${CONSTANT.BASE_API}auth/forgot-password`,
        PROFILE: `${CONSTANT.SHOP_API}users/profile`,
    },
    USER: {
        CHECK: `${CONSTANT.BASE_API}users/check`,
        ACTIVE: `${CONSTANT.BASE_API}users/active`,
        CHANGE_PASS: `${CONSTANT.SHOP_API}users/change-password`,
        UPDATE: `${CONSTANT.SHOP_API}users/profile`,
        ORDER_TRACKING_LOGS: `${CONSTANT.SHOP_API}shop/product/order-tracking-log/list`
    },
    AGENCY: {
        AGENCY: `${CONSTANT.SHOP_API}agency`,
        AGENCY_INFO: `${CONSTANT.SHOP_API}agency`,
        IMAGE: `${CONSTANT.SHOP_API}agency/image`,
        CONFIRM_ORDER: `${CONSTANT.SHOP_API}agency/confirm-order`,
        UPDATE_SHIPPING_ORDER: `${CONSTANT.SHOP_API}agency/update-shipping-order`
    },
    PRODUCT: {
        PRODUCT: `${CONSTANT.SHOP_API}shop/product/product`,
        VARIANT: `${CONSTANT.SHOP_API}shop/product/variant`,
        ATTRIBUTE: `${CONSTANT.SHOP_API}shop/product/attribute`,
        CATEGORY: `${CONSTANT.SHOP_API}shop/product/category/tree`,
        IMAGE: `${CONSTANT.SHOP_API}shop/product/image`,
        ORDER: `${CONSTANT.SHOP_API}shop/product/order`,
        PAYMENT: `${CONSTANT.SHOP_API}shop/product/order-checkout`,
        ADDRESS_STORE_LIST: `${CONSTANT.SHOP_API}shop/address/stores`,
        ADDRESS_STORE: `${CONSTANT.SHOP_API}shop/address/store`,
    },
    TRANSACTION: {
        TRANSACTION: `${CONSTANT.BASE_API}shop/product/order/payment`
    },
    MEDIA: {
        MEDIA: `${CONSTANT.BASE_API}audio/media`,
        UPLOAD_IMAGE: `${CONSTANT.BASE_API}audio/media/upload/image`,
        SAVE_FILE: `${CONSTANT.BASE_API}audio/media/upload/save-file`
    },
    EXTRA: {
        UPLOAD_AVATAR: `${CONSTANT.BASE_API}extra/upload/avatar`,
        UPLOAD_IMAGE: `${CONSTANT.SHOP_API}extra/upload/temp`,
        SAVE_FILE: `${CONSTANT.SHOP_API}extra/upload/save-file`,
    },
    DESTINATION: {
        AREA: `${CONSTANT.BASE_API}destination/area`,
        COUNTRY: `${CONSTANT.BASE_API}destination/country`,
        CITY: `${CONSTANT.BASE_API}destination/city`
    },
    AUDIO_OBJECT: `${CONSTANT.BASE_API}audio/audio-object`,
    CONTENT: `${CONSTANT.BASE_API}audio/content`,
}

CONSTANT.STORAGE_KEY_USER = `auth-user-${process.env.NODE_ENV}`;
CONSTANT.DATE_FORMAT = 'DD/MM/YY - H:m';
CONSTANT.STATUS = {
    trash: 'Nháp',
    processing: 'Đang xử lý',
    completed: 'Hoàn thành',
    cancelled: 'Hủy',
    paid: 'Đã thanh toán',
    unpaid: 'Không thanh toán',
    wait_paid: 'Chờ thanh toán',
    pending: 'Chưa giải quyết'
}
CONSTANT.STATUS_COLOR = {
    trash: 'default',
    processing: 'orange',
    completed: 'green',
    cancelled: 'magenta',
    paid: 'geekblue',
    unpaid: 'volcano',
    wait_paid: 'gold',
    pending: 'purple'
}

export default CONSTANT;
